import styled from "styled-components";

function NavBar() {
    return(
        <MasterContainer>
            <MenuItem>Questionário</MenuItem>
            <MenuItem>Informações</MenuItem>
            <MenuItem>Contato</MenuItem>
        </MasterContainer>
    );

}

export default NavBar;

const MasterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid;
    width: 600px;
    margin-top: 10px;
    border-radius: 10px;
    //background-color: rgba(0,0,0,.5);
    padding: 5px 0; 

`
const MenuItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid;
    padding: 10px 20px;
    font-size: 14pt;
    margin-right: 30px;
    transition: .3s ease-in-out;
    cursor: pointer;
    width: 100px;
    font-weight: bold;
    border-radius: 5px;

    &:hover {
        scale: 1.1;
        color: white;
        background-color: rgba(0,0,0,.7);
    }

`